<template>
  <div>
    <v-list-item :style="`margin-left: ${(category.level * 40)}px`" class="white my-2" link
                 @click="editCategory(category)">
      <v-list-item-avatar>
        <v-icon v-if="loading">mdi mdi-loading mdi-spin</v-icon>
        <v-icon v-else-if="category.level > 0">mdi mdi-subdirectory-arrow-right</v-icon>
        <v-icon v-else>mdi mdi-check</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          {{ category.nameText }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ category.engineName }}
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          {{ category.descriptionText }}
        </v-list-item-subtitle>
        <v-list-item-subtitle><small>{{ type }}</small></v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-menu top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs"
                   v-on="on">
              <v-icon>mdi mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item color="error" link @click="deleteCategory(category)">
              <v-list-item-icon>
                <v-icon>mdi mdi-delete</v-icon>
              </v-list-item-icon>
              <v-list-item-subtitle>
                {{ $t('delete') }}
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>

        </v-menu>
      </v-list-item-action>
    </v-list-item>
    <template v-for="childCategory in category.children">
      <category-item :key="childCategory.id" :category="childCategory" @edit="editCategory"
                     @reload="$emit('reload')"></category-item>
    </template>
  </div>

</template>

<script>
import categoryApi from '@/api/category';

export default {
  name: "CategoryItem",
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  computed: {
    type() {
      return this.category?.type?.map(t => {
        return this.$categoryTypes.find(ct => ct.value === t).text;
      }).join(', ');
    }
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    editCategory(category) {
      this.$emit('edit', category);
    },
    async deleteCategory(category) {
      this.loading = true;
      try {
        await categoryApi.deleteCategory(category.id)
        this.$emit('reload');
      } catch (e) {
        this.$handleApiError(e, this.$t('categories.errors.error_deleting'));
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>

</style>
